import { snakeToCamelObj } from '@/common/converter/utils/snake-to-camel-obj'

export const normalizeContext = (rawData) => {
  return snakeToCamelObj(rawData)
}
